
import React, { Component } from 'react';

import { COLOR, MAX } from "../../modules/constants"

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { withStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';

const styles = theme => ({
  title: {
    minHeight: 130,
  },
  text: {
    whiteSpace: "pre-wrap",
    color: "black",
  },
  warningText: {
    whiteSpace: "pre-wrap",
    color: COLOR.BAD,
  },
});

// If idsList.length hasn't changed for this long while the modal is open, treat the connections
// fetch as stalled and auto-cancel via the same path the visible Cancel button uses. Closing this
// modal normally depends on NexusPage's componentDidUpdate re-entering a specific check once
// nexusStatus returns to STATUS.NEXUS.CLEAR (see getData/watchGetEntities in nexusModule.js) -
// if that never happens (e.g. an exception mid-fetch that's swallowed without resetting status),
// the modal is otherwise left open indefinitely with no way for the user to tell what's wrong.
const STALL_TIMEOUT_MS = 20_000

class ProgressModal extends Component {
  stallTimer = null
  lastIdsListLength = null

  componentDidMount() {
    if (this.props.show)
      this.startStallTimer()
  }

  componentDidUpdate(prevProps) {
    const { idsList, show } = this.props

    if (!show) {
      this.clearStallTimer()
      this.lastIdsListLength = null
      return
    }

    // (Re)start the clock on first showing, or on genuine progress - only a sustained lack of
    // change should be treated as stalled.
    if (!prevProps.show || idsList.length !== this.lastIdsListLength)
      this.startStallTimer()
  }

  componentWillUnmount() {
    this.clearStallTimer()
  }

  startStallTimer() {
    this.lastIdsListLength = this.props.idsList.length
    this.clearStallTimer()
    this.stallTimer = setTimeout(() => {
      console.warn(`ProgressModal: no progress for ${STALL_TIMEOUT_MS}ms - auto-cancelling a stalled connections fetch`)
      this.props.onCancel()
    }, STALL_TIMEOUT_MS)
  }

  clearStallTimer() {
    if (this.stallTimer) {
      clearTimeout(this.stallTimer)
      this.stallTimer = null
    }
  }

  render() {
    const { connections, idsList } = this.props
    
    let title1 = idsList.length > 0
      ? "Getting connections for:"
      : `Finishing up...`

    let title2 = idsList.length > 0
      ? `${idsList[idsList.length - 1].name}`
      : ""

    const centre = `${idsList.length} of ${Math.min(connections, MAX.SECOND_LEVEL)} remaining`
    const warning1 = `Numerable gets connections for a maximum of ${MAX.SECOND_LEVEL} people or companies`
    const warning2 = `Your initial list has ${connections}, so only connections for ${MAX.SECOND_LEVEL} will be found`
    const showWarning = connections > MAX.SECOND_LEVEL

    return (
      <Dialog open={Boolean(this.props.show)} onClose={this.props.onHide} maxWidth="sm" fullWidth>

        <DialogTitle>
          <div>
            <CircularProgress size={24} /> &nbsp;{title1}
          </div>
        </DialogTitle>

        <DialogTitle className={this.props.classes.title}>
          {title2}
        </DialogTitle>

        <DialogContent>
          <DialogContentText className={this.props.classes.text}>{centre}</DialogContentText>
        </DialogContent>

        {showWarning &&
          <React.Fragment>
            <DialogContent>
              <DialogContentText className={this.props.classes.warningText}>{warning1}</DialogContentText>
            </DialogContent>

            <DialogContent>
              <DialogContentText className={this.props.classes.warningText}>{warning2}</DialogContentText>
            </DialogContent>
          </React.Fragment>
        }

        <DialogActions>
          <Button onClick={this.props.onCancel} color="primary">
            Cancel
          </Button>
        </DialogActions>

      </Dialog>
    )
  }
}
export default withStyles(styles)(ProgressModal);
